import {createApp} from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/index.css'
import VueSmoothScroll from 'vue3-smooth-scroll'
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import mitt from 'mitt';
import Toaster from "@meforma/vue-toaster";

import { axiosPlugin } from "@/plugins/axios"
import i18n from './i18n'

const app = createApp(App).use(i18n);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const head = createHead();
const emitter = mitt();

app.config.globalProperties.emitter = emitter;

const params = new URLSearchParams(window.location.search)
const utm = {
    source: params.get('utm_source'),
    medium: params.get('utm_medium'),
    campaign: params.get('utm_campaign'),
    content: params.get('utm_content')
}
if (utm.source) localStorage.setItem('utm', JSON.stringify(utm))


app.use(store);
app.use(i18n);
app.use(pinia);
app.use(router);
app.use(axiosPlugin);
app.use(VCalendar, {});
app.use(Toaster);
app.use(VueSmoothScroll, {
    updateHistory: false
});
app.use(head)

app.mount('#app')
